import Insight from './Insight'
import SkeletonInsight from './SkeletonInsight'
import './Insight.scss'

export { SkeletonInsight }
export default Insight